import React, { Component } from 'react'
import { t } from 'i18next'

export default class Legend extends Component {
  render() {
    const { activeHouse, backToProjects } = this.props

    return (
      <div className="legend">
        <h3>{activeHouse.title}</h3>
        <div className="fields">

          <dl>
            <dt>{t('houses.usable_area')}</dt>
            <dd>{activeHouse.usable_net.match(/^([^/]+)/g, '')} m²</dd>
          </dl>

          <dl>
            <dt>{t('houses.net_floor')}</dt>
            <dd>{activeHouse.usable_net.replace(/^([^/]+)/g, '').replace('/ ', '')}</dd>
          </dl>

          <dl>
            <dt>{t('houses.building_area')}</dt>
            <dd>{activeHouse.building_area}</dd>
          </dl>

          <dl>
            <dt>{t('houses.cubic_capacity')}</dt>
            <dd>{activeHouse.cubic_capacity}</dd>
          </dl>

          <dl>
            <dt>{t('houses.height')}</dt>
            <dd>{activeHouse.height}</dd>
          </dl>

          <dl>
            <dt>{t('houses.roof_slope')}</dt>
            <dd>{activeHouse.roof_slope}</dd>
          </dl>

          <dl>
            <dt>{t('houses.roof_area')}</dt>
            <dd>{activeHouse.roof_area}</dd>
          </dl>

          <dl>
            <dt>{t('houses.minimum_plot_size')}</dt>
            <dd>{activeHouse.minimum_plot_size}</dd>
          </dl>

          <dl>
            <dt>{t('houses.levels')}</dt>
            <dd>{activeHouse.levels}</dd>
          </dl>

          <dl>
            <dt>{t('houses.rooms')}</dt>
            <dd>{activeHouse.rooms}</dd>
          </dl>

          <button onClick={() => backToProjects()}>{t('back_to_projects')}</button>

        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/Components/Houses/legend.js